import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { routes } from '@/configs/router/routes';

export const routerProvider = (
  <RouterProvider router={createBrowserRouter(routes)}></RouterProvider>
);
